import { AxiosInstance } from "axios";
import { CredentialSchema } from "../../Schemas/User";
import { IResponseBody } from "../../Schemas/EndPoint";

export interface TokenRequestBody {
  mobile: string;
  password: string;
}

export interface TokenResponseBody extends IResponseBody {
  data: {
    credential: CredentialSchema;
  };
}

export class TokenRequest {
  private path = "/auth/admin/token";
  private publicAxiosInstance;

  constructor(publicAxiosInstance: AxiosInstance) {
    this.publicAxiosInstance = publicAxiosInstance;
  }

  async send(requestBody: TokenRequestBody): Promise<TokenResponseBody> {
    try {
      const { data } = await this.publicAxiosInstance.post(
        this.path,
        requestBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
